import React from 'react';
import {
  Box,
  Card,
  CardContent,
  Typography,
  Alert,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from '@mui/material';
import { Building2, CreditCard, Shield, Zap } from 'lucide-react';
import './SavedCards.css';

/**
 * SavedCards Component (Updated for Stitch)
 * 
 * With Stitch payments, we don't save payment methods.
 * Instead, users complete payments securely through Stitch each time.
 */
const SavedCards = () => {
  return (
    <Card>
      <CardContent>
        <Typography variant="h6" gutterBottom>
          Payment Methods
        </Typography>

        <Alert severity="info" sx={{ mb: 3 }}>
          <Typography variant="body2" sx={{ fontWeight: 600, mb: 0.5 }}>
            Secure Payment via Stitch
          </Typography>
          <Typography variant="body2">
            For your security, we don't store payment details. Each time you book a service, 
            you'll complete payment securely through Stitch.
          </Typography>
        </Alert>

        <Typography variant="subtitle2" sx={{ mb: 2, color: 'text.secondary' }}>
          Available Payment Options:
        </Typography>

        <List>
          <ListItem>
            <ListItemIcon>
              <Building2 size={24} color="#1976d2" />
            </ListItemIcon>
            <ListItemText 
              primary="Instant EFT"
              secondary="Pay directly from your bank account - no card needed"
            />
          </ListItem>

          <ListItem>
            <ListItemIcon>
              <CreditCard size={24} color="#1976d2" />
            </ListItemIcon>
            <ListItemText 
              primary="Card Payment"
              secondary="Visa, Mastercard, and other major cards"
            />
          </ListItem>

          <ListItem>
            <ListItemIcon>
              <Zap size={24} color="#1976d2" />
            </ListItemIcon>
            <ListItemText 
              primary="Instant Processing"
              secondary="Payments are processed immediately"
            />
          </ListItem>

          <ListItem>
            <ListItemIcon>
              <Shield size={24} color="#1976d2" />
            </ListItemIcon>
            <ListItemText 
              primary="Bank-Grade Security"
              secondary="All transactions are encrypted and secure"
            />
          </ListItem>
        </List>

        <Box sx={{ mt: 2, p: 2, bgcolor: 'grey.50', borderRadius: 1 }}>
          <Typography variant="body2" color="text.secondary">
            💡 <strong>Tip:</strong> When you book a service, you'll be redirected to Stitch's 
            secure payment page to complete your transaction.
          </Typography>
        </Box>
      </CardContent>
    </Card>
  );
};

export default SavedCards;
